import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnChanges,
  OnInit,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[expandedView]',
})
export class VaExpandDirective implements OnChanges, OnInit {
  @Input() item: any;
  @Input() view: any;

  component: ComponentRef<any>;

  constructor(private resolver: ComponentFactoryResolver, private container: ViewContainerRef) {}

  ngOnChanges(): void {
    if (this.component) {
      this.component.instance.item = this.item;
      this.component.instance.view = this.view;
    }
  }

  ngOnInit(): void {
    const component = this.resolver.resolveComponentFactory(this.view);
    this.component = this.container.createComponent(component);
    this.component.instance.item = this.item;
  }
}
